import { InputSearch } from "./inputsearch";
import { Stationselect } from "./select";

function StationPicker(props: any) {
  return (
    <div>
      {props.useinputsearch ? (
        <InputSearch
          type={props.type}
          useapi={props.useapi}
          regioncodes={props.regioncodes}
          rangelimit={props.rangelimit}
          resultlimit={props.resultlimit}
          enabledstations={props.enabledstations}
        />
      ) : (
        <Stationselect type={props.type} />
      )}
    </div>
  );
}
export default StationPicker;
